import React from "react";

import { Trans, useTranslation } from "@lib/i18n";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { useIsHomeDeliveryEnabled } from "@hooks/useIsHomeDeliveryEnabled";

const CLASSNAMES = {
  ADVANTAGE: "flex items-center py-4 lowercase flex-1-1-0 sm:flex-col",
  ADVANTAGE_TEXT:
    "block text-black py-4 w-7/10 sm:mt-0 sm:w-9/10 sm:text-center text-balance",
  IMAGE: "max-w-12 max-h-12 sm:max-w-none sm:max-h-none",
  IMAGE_CONTAINER: "flex justify-center w-20",
};

const Perks = () => {
  const { t } = useTranslation();
  const isHomeDeliveryEnabled = useIsHomeDeliveryEnabled();

  return (
    <div className="w-full max-w-pageContent px-8 py-4 mx-auto my-0 bg-primaryLight sm:p-4">
      <p
        className="text-black font-semibold my-4 uppercase"
        data-id="footer-section-buy"
      >
        <Trans i18nKey={"footer.sections.buy.title"} />
      </p>
      <div
        className="flex flex-col justify-between mb-8 sm:flex-row"
        data-id="footer-journey-advantages"
      >
        <div className={CLASSNAMES.ADVANTAGE}>
          <div className={CLASSNAMES.IMAGE_CONTAINER}>
            <img
              alt={t("features.onlineProcess")}
              className={CLASSNAMES.IMAGE}
              src={getStaticAssetURL("/icons/footer_achat_en_ligne.png")}
              title={t("features.onlineProcess")}
            />
          </div>
          <p className={CLASSNAMES.ADVANTAGE_TEXT}>
            <Trans i18nKey={"features.onlineProcess"} />
          </p>
        </div>
        <div className={CLASSNAMES.ADVANTAGE}>
          <div className={CLASSNAMES.IMAGE_CONTAINER}>
            <img
              alt={t("features.instantFinancing")}
              className={CLASSNAMES.IMAGE}
              src={getStaticAssetURL("/icons/footer_flexible.png")}
              title={t("features.instantFinancing")}
            />
          </div>
          <p className={CLASSNAMES.ADVANTAGE_TEXT}>
            <Trans i18nKey={"features.instantFinancing"} />
          </p>
        </div>
        <div className={CLASSNAMES.ADVANTAGE}>
          <div className={CLASSNAMES.IMAGE_CONTAINER}>
            <img
              alt={t("features.trialPeriod")}
              className={CLASSNAMES.IMAGE}
              src={getStaticAssetURL("/icons/footer_changer_avis.png")}
              title={t("features.trialPeriod")}
            />
          </div>
          <p className={CLASSNAMES.ADVANTAGE_TEXT}>
            <Trans i18nKey={"features.trialPeriod"} />
          </p>
        </div>
        <div className={CLASSNAMES.ADVANTAGE}>
          <div className={CLASSNAMES.IMAGE_CONTAINER}>
            <img
              alt={t("features.customerSupport")}
              className={CLASSNAMES.IMAGE}
              src={getStaticAssetURL("/icons/footer_chat.png")}
              title={t("features.customerSupport")}
            />
          </div>
          <p className={CLASSNAMES.ADVANTAGE_TEXT}>
            <Trans i18nKey={"features.customerSupport"} />
          </p>
        </div>
        {isHomeDeliveryEnabled && (
          <div className={CLASSNAMES.ADVANTAGE}>
            <div className={CLASSNAMES.IMAGE_CONTAINER}>
              <img
                alt={t("features.network")}
                className={CLASSNAMES.IMAGE}
                src={getStaticAssetURL("/icons/footer_localisation.png")}
                title={t("features.network")}
              />
            </div>
            <p className={CLASSNAMES.ADVANTAGE_TEXT}>
              <Trans i18nKey={"features.network"} />
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Perks;
